/**
 * Entra (Azure AD) configuration for Nested App Authentication.
 *
 * The client ID is filled in after the B1 app registration (docs/
 * entra-app-registration.md). Until then it stays empty and the add-in runs in
 * manual-key mode (isAuthConfigured() === false) — nothing breaks.
 *
 * No client secret: NAA is a PUBLIC client. The add-in only ever obtains a
 * delegated ID token for the signed-in user; the LiteLLM key never lives in
 * client config — the broker holds it (see docs/ai-redline-engine.md siblings).
 */
export const TENANT_ID = 'fa52f598-ed37-44eb-b535-9cf1d456c240';

/** Application (client) ID from the Entra registration (B1, 2026-07-23). */
export const CLIENT_ID = 'bdadd1bd-d0e8-4276-812f-0e6d90ae470d';

/** Scopes requested for the ID token. User.Read yields a signed-in identity;
 * the broker needs only the resulting ID token, not a Graph access token. */
export const LOGIN_SCOPES = ['User.Read', 'openid', 'profile', 'email'];

export const AUTHORITY = `https://login.microsoftonline.com/${TENANT_ID}`;

/** True once B1 is done and CLIENT_ID is set — gates all auth code paths. */
export function isAuthConfigured(): boolean {
  return CLIENT_ID.trim().length > 0;
}
